<template>
  <div class="">
    <label for="">جست و جو</label>
    <b-form-input
        @keypress.enter="submit"
        v-model="searchWords"
        placeholder="جستجو"
    ></b-form-input>
  </div>
</template>


<script>
export default {
  name: "SearchFilter1",
  data() {
    return {
      searchWords: ''
    }
  },
  methods: {
    submit() {
      this.$emit('search', {searchWords:this.searchWords})
    }
  }
}
</script>

<style scoped>

</style>